import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SessionGuard = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const loginTime = localStorage.getItem('loginTime');

    if (!token || !loginTime) {
      return navigate('/signin');
    }

    const sessionAge = Date.now() - parseInt(loginTime, 10);
    const fifteenHours = 15 * 60 * 60 * 1000; // 15 hours in ms

    if (sessionAge > fifteenHours) {
      localStorage.clear();
      alert('Session expired. Please login again.');
      return navigate('/signin');
    }

    // ✅ No redirect if session is still valid
  }, [navigate]);

  return children;
};

export default SessionGuard;
